<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Cadastro de Documento'">
          <template v-slot:preview>
            <v-form v-model="valid" ref="form">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-select
                      :items="grupos"
                      label="Selecione um Grupo"
                      item-text="nome"
                      item-value="id"
                      v-model="documento.grupoDocumentoID"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="7">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model.trim="documento.nome"
                          label="Nome"
                          clearable
                          :rules="[rules.required, rules.maxLength]"
                          required
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <span
                        style="
                          white-space: normal;
                          max-width: 300px;
                          display: block;
                          word-wrap: break-word;
                        "
                        >{{ documento.nome }}</span
                      >
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-select
                      :items="criticidades"
                      label="Criticidade"
                      item-text="nome"
                      item-value="id"
                      v-model="documento.criticidadeID"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-switch
                      v-model="documento.bloqueiaPagamento"
                      :label="'Bloqueia Pagamento?'"
                    ></v-switch>
                    <v-switch
                      v-model="documento.obrigatorio"
                      :label="'Obrigatório?'"
                    ></v-switch>
                    <v-switch
                      v-model="documento.workFlow"
                      :label="'Necessita aprovação?'"
                    ></v-switch>
                  </v-col>

                  <v-col cols="12" sm="5">
                    <h5>Tipos de documentos</h5>
                    <v-radio-group v-model="documento.tipoDocumentoID" row>
                      <v-radio
                        v-for="tipo in tiposDocumento"
                        :key="tipo.id"
                        :label="tipo.nome"
                        :value="tipo.id"
                      ></v-radio>
                    </v-radio-group>

                    <v-col cols="12" sm="12">
                      <h5>Extensões Permitidas</h5>

                      <v-row class="justify-space-between">
                        <v-checkbox
                          v-for="tipo in tiposExtensao"
                          :key="tipo.id"
                          :label="tipo.nome"
                          :value="tipo.id"
                          v-model="documento.extensoesID"
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    v-if="documento.tipoDocumentoID === 1"
                  >
                    <v-text-field
                      v-model="documento.periodocidade"
                      label="Periodicidade (em meses)"
                      clearable
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="documento.dataVigenciaInicio"
                      label="Inicio Data Vigencia"
                      clearable
                      type="date"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="documento.tipoDocumentoID === 4">
                    <v-text-field
                      v-model="documento.diasAlertaValidade"
                      label="Alerta vencimento a partir de "
                      clearable
                      suffix="Dias"
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-btn @click="voltar" color="error" large>Voltar</v-btn>
                <v-btn
                  @click="salvar"
                  color="primary"
                  large
                  class="ml-2"
                  :disabled="saving"
                  >Salvar</v-btn
                >
              </v-container>
            </v-form>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <TelaLoading :overlay="saving"></TelaLoading>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import moment from "moment";

export default {
  name: "documentoCadastro",
  data() {
    return {
      valid: false,
      saving: false,
      documento: {
        id: 0,
        clienteID: 0,
        nome: "",
        temValidade: false,
        criticidadeID: "",
        score: 0,
        bloqueiaPagamento: false,
        periodocidade: 0,
        tipoDocumentoID: 1,
        grupoDocumentoID: 0,
        extensoesID: [],
        obrigatorio: false,
        workFlow: true,
        dataVigenciaInicio: null,
        diasAlertaValidade: null,
      },
      criticidades: [
        { id: 1, nome: "Baixa" },
        { id: 2, nome: "Média" },
        { id: 3, nome: "Alta" },
      ],
      rules: {
        required: (v) => !!v || "Obrigatório",
        maxLength: (v) => (v && v.length <= 250) || "Máximo de 250 caracteres",
      },
      cliente: {},
      tiposDocumento: [
        { id: 1, nome: "Periódico" },
        { id: 2, nome: "De Início" },
        { id: 3, nome: "De Fim" },
        { id: 4, nome: "Validade" },
        { id: 5, nome: "Manual" },
      ],
      tiposExtensao: [
        { id: 1, nome: "PDF" },
        { id: 2, nome: "Imagens" },
        { id: 3, nome: "Excel" },
        { id: 4, nome: "Word" },
        { id: 5, nome: "Zip" },
        { id: 6, nome: "DWG" },
      ],
      grupos: [],
    };
  },
  components: {
    KTCodePreview,
    TelaLoading,
  },
  watch: {
    "documento.tipoDocumentoID"() {
      if (this.documento.tipoDocumentoID !== 1) {
        this.documento.dataVigenciaInicio = null;
      }
    },
  },
  methods: {
    listarGrupos() {
      return new Promise((resolve) => {
        ApiService.get("grupodocumento/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            if (data.success) {
              resolve(data);
              this.grupos = data.data;
            } else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    salvar() {
      let self = this;

      if (this.$refs.form.validate()) {
        this.saving = true;

        if (this.documento.id === 0) {
          return new Promise((resolve) => {
            ApiService.post("documento", this.documento).then(({ data }) => {
              if (data.success) {
                resolve(data);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Documento Cadastrado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.$router.push({ name: "documento" });
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        } else {
          this.documento.cliente = null;

          return new Promise((resolve) => {
            ApiService.put(
              "documento/" + this.documento.id,
              this.documento
            ).then(({ data }) => {
              if (data.success) {
                resolve(data);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Documento Alterado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.$router.push({ name: "documento" });
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        }
      }
    },

    buscarDocumento(id) {
      return new Promise((resolve) => {
        ApiService.get("documento/" + id).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.documento = data.data;

            if (this.documento.dataVigenciaInicio) {
              this.documento.dataVigenciaInicio = moment(
                this.documento.dataVigenciaInicio
              ).format("yyyy-MM-DD");
            }
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    voltar() {
      history.go(-1);
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Documentos" }]);

    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.documento.clienteID = this.cliente.id;

    this.listarGrupos();

    if (this.$route.params.id !== undefined)
      this.buscarDocumento(this.$route.params.id);
  },
  created() {
    let permissao = Permissoes.Incluir;

    if (this.$route.params.id !== undefined) permissao = Permissoes.Editar;

    if (!PermissoesService.verificarAcesso(Modulo.Documento, permissao)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
